<template>
  <div>
    <div
      ref="bienvenidaRef"
      class="bienvenida-container"
    >
      <div class="mensaje-container">
        <h2>Libro de Firmas:</h2>
        <textarea
          v-model="nuevoMensaje"
          placeholder="Tu mensaje aquí..."
          rows="4"
          maxlength="500"
          @input="verificarLongitud"
        />
        <div class="contador">
          {{ caracteresRestantes }} caracteres restantes
        </div>

        <input
          v-model="localNombre"
          type="text"
          placeholder="Tu nombre aquí..."
          class="nombre-input"
        >
        <button @click="enviarMensaje">
          Enviar
        </button>

        <div class="mensajes-enviados">
          <h3>Mensajes recibidos:</h3>
          <div
            v-for="(mensajeObj, index) in mensajes"
            :key="index"
            class="mensaje-tarjeta"
          >
            <strong>{{ mensajeObj.nombre }}:</strong> {{ mensajeObj.mensaje }}
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { onMounted, ref, nextTick, computed } from 'vue';
import axios from 'axios';
import baseUrl from '@/api';  // Asegúrate de importar la URL base


export default {
  name: 'BienvenidaPage',
  props: {
    idInvitado: {
      type: Number,
      required: true,
      validator(value) {
        return !isNaN(value) && value > 0;
      }
    },
    nombre: {
      type: String,
      default: '',
    },
    idFestejado: {
      type: Number,
      default: null,
    }
  },
  setup(props) {
    const bienvenidaRef = ref(null);
    const nuevoMensaje = ref('');
    const localNombre = ref('');
    const mensajes = ref([]);
    const animationDone = ref(false);
    const maxCaracteres = 500; // Cambia este número según tus necesidades
    const caracteresRestantes = computed(() => maxCaracteres - nuevoMensaje.value.length);
  
    const verificarLongitud = () => {
      if (nuevoMensaje.value.length > 500) {
        nuevoMensaje.value = nuevoMensaje.value.slice(0, 500);
      }
    };
    // Función para obtener mensajes al montar el componente
    const obtenerMensajes = async () => {
      try {
        const response = await axios.get(`${baseUrl}/mensajes?idFestejado=${props.idFestejado}`);
        mensajes.value = response.data; // Asume que la respuesta es un array de objetos con nombre y mensaje
      } catch (error) {
        console.error('Error al obtener los mensajes:', error);
      }
    };

    const enviarMensaje = async () => {
      if (nuevoMensaje.value.trim() && localNombre.value.trim()) {
        console.log('Datos a enviar:', {
          mensaje: nuevoMensaje.value.trim(),
          idFestejado: props.idFestejado,
          idInvitado: props.idInvitado,
          nombre: localNombre.value.trim(),
        });

        try {
  const response = await axios.post(`${baseUrl}/mensajes`, {
    mensaje: nuevoMensaje.value.trim(),
    idFestejado: props.idFestejado,
    idInvitado: props.idInvitado,
    nombre: localNombre.value.trim(),
  });
          console.log(response.data); // Mensaje de éxito
          
          // Agregar el mensaje como objeto
          mensajes.value.push({
            nombre: localNombre.value.trim(),
            mensaje: nuevoMensaje.value.trim()
          });

          nuevoMensaje.value = '';
          localNombre.value = '';
        } catch (error) {
          console.error('Error al guardar el mensaje:', error);
        }
      }
    };

    onMounted(async () => {
      await obtenerMensajes(); // Llamar a la función para obtener mensajes
      await nextTick();
      if (bienvenidaRef.value) {
        const element = bienvenidaRef.value;

        const observerOptions = {
          root: null,
          rootMargin: '0px',
          threshold: [0.1],
        };

        const observerCallback = (entries) => {
          entries.forEach(entry => {
            if (entry.isIntersecting) {
              if (!animationDone.value) {
                element.classList.add('animate__animated', 'animate__fadeInUp');
                element.addEventListener('animationend', () => {
                  element.classList.remove('animate__animated', 'animate__fadeInUp');
                  element.style.opacity = '1';
                }, { once: true });

                animationDone.value = true;
              }
            } else {
              element.style.opacity = '0';
              animationDone.value = false;
            }
          });
        };

        const observer = new IntersectionObserver(observerCallback, observerOptions);
        observer.observe(element);
      }
    });

    return { bienvenidaRef, nuevoMensaje, localNombre, mensajes, enviarMensaje,caracteresRestantes,verificarLongitud };
  },
};
</script>
<style scoped>
/* Contenedor Mensaje de Bienvenida - Enfoque Corporativo */
.bienvenida-container {
  position: relative;
  width: 100%;
  padding: 40px 20px;
  /* Fondo profesional con sutil textura */
  background: linear-gradient(to bottom, #ffffff, #f1f5f9);
  margin: 0;
  text-align: center;
  display: flex;
  flex-direction: column;
  align-items: center;
  border-radius: 4px; /* Bordes más rectos para formalidad */
  border-top: 5px solid #121752;
  box-shadow: 0 4px 20px rgba(0, 0, 0, 0.08);
  transition: all 0.3s ease;
}

.bienvenida-container:hover {
  transform: translateY(-2px);
  box-shadow: 0 6px 25px rgba(0, 0, 0, 0.12);
}

.mensaje-bienvenida {
  font-size: 1.75rem !important;
  font-weight: 700;
  font-family: 'hombre', Roboto, sans-serif;
  color: #121752;
  text-transform: uppercase;
  letter-spacing: 1px;
  margin-bottom: 10px;
}

/* Contenedor del ícono */
.icono-container {
  margin: 15px 0;
}

.icono {
  font-size: 28px;
  color: #121752;
  opacity: 0.8;
  /* Animación más sutil y profesional */
  animation: pulsar 2s infinite ease-in-out;
}

@keyframes pulsar {
  0% { transform: scale(1); opacity: 0.8; }
  50% { transform: scale(1.1); opacity: 1; }
  100% { transform: scale(1); opacity: 0.8; }
}

.texto-adicional {
  font-size: 16px;
  font-weight: 400;
  font-family: 'Segoe UI', sans-serif;
  color: #64748b;
  margin-top: 10px;
}

/* Estilos para el contenedor de mensajes (Formulario) */
.mensaje-container {
  width: 100%;
  max-width: 600px;
  margin-top: 30px;
  padding: 30px;
  border-radius: 4px;
  background-color: #ffffff;
  border: 1px solid #e2e8f0;
  box-shadow: 0 2px 10px rgba(0, 0, 0, 0.05);
}

.mensaje-container h2 {
  font-size: 1.75rem !important;
  font-family: 'hombre', sans-serif;
  font-weight: 700;
  color: #121752;
  margin-bottom: 20px;
  text-align: center;
  text-transform: uppercase;
  letter-spacing: 0.5px;
}

/* Inputs y Textarea Ejecutivos */
.mensaje-container textarea,
.nombre-input {
  width: 100%;
  padding: 12px 15px;
  margin-bottom: 15px;
  border: 1px solid #cbd5e1;
  border-radius: 2px;
  font-family: 'Segoe UI', sans-serif;
  font-size: 14px;
  color: #1e293b;
  background-color: #fcfcfc;
  transition: all 0.2s ease;
}

.mensaje-container textarea:focus,
.nombre-input:focus {
  border-color: #121752;
  background-color: #ffffff;
  box-shadow: 0 0 0 3px rgba(18, 23, 82, 0.1);
  outline: none;
}

/* Botón de Envío */
.mensaje-container button {
  width: 100%;
  padding: 12px;
  background-color: #121752;
  color: #ffffff;
  font-family: 'Segoe UI', sans-serif;
  font-weight: 700;
  font-size: 14px;
  text-transform: uppercase;
  letter-spacing: 1px;
  border: none;
  border-radius: 2px;
  cursor: pointer;
  transition: all 0.3s ease;
}

.mensaje-container button:hover {
  background-color: #0a0d2e;
  box-shadow: 0 4px 12px rgba(18, 23, 82, 0.2);
}

/* Contador de caracteres */
.contador {
  font-size: 12px;
  font-family: 'Segoe UI', sans-serif;
  color: #94a3b8;
  text-align: right;
  margin-top: -10px;
  margin-bottom: 15px;
}

/* Mensajes Enviados (Listado) */
.mensajes-enviados {
  width: 100%;
  max-width: 600px;
  margin-top: 30px;
  text-align: left;
}

.mensajes-enviados h3 {
  font-size: 16px;
  font-family: 'Segoe UI', sans-serif;
  font-weight: 700;
  color: #334155;
  border-left: 4px solid #121752;
  padding-left: 10px;
  margin-bottom: 15px;
}

/* Tarjeta de Mensaje Individual */
.mensaje-tarjeta {
  padding: 15px 20px;
  margin-bottom: 12px;
  background: #ffffff;
  border-radius: 2px;
  border-left: 3px solid #e2e8f0;
  box-shadow: 0 2px 5px rgba(0, 0, 0, 0.05);
  transition: all 0.3s ease;
}

.mensaje-tarjeta:hover {
  border-left-color: #121752;
  transform: translateX(5px);
  box-shadow: 0 4px 10px rgba(0, 0, 0, 0.08);
}

.mensaje-tarjeta p {
  font-family: 'Segoe UI', sans-serif;
  font-size: 14px;
  color: #475569;
  line-height: 1.6;
}

.mensaje-tarjeta .autor {
  font-weight: 700;
  color: #121752;
  margin-top: 5px;
  font-size: 13px;
}
</style>